import $ from 'jquery';
import 'ion-rangeslider';
import 'ion-rangeslider/css/ion.rangeSlider.min.css';

export function initRangeSlider ($elements) {
	$elements.each((i, el) => {
		const $el = $(el);

		const $container = $el.closest('[data-range-slider-container]');

		$el.ionRangeSlider({
			onChange: (data) => {
				if ($container.length) {
					const min = $container.find('[data-range-slider-min]');
					const max = $container.find('[data-range-slider-max]');
					min.val(data.from).trigger('input');
					max.val(data.to).trigger('input');
				}
			}
		});
	});
}



// WEBPACK FOOTER //
// ./_HTML/src/js/_modules/range-slider/index.js